var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorizationMatrix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9854",
    "data-name": "Group 9854",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5638",
    "data-name": "Rectangle 5638",
    width: 492,
    height: 492,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 512,
    height: 512,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10040",
    "data-name": "Group 10040",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10039",
    "data-name": "Group 10039",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6881",
    "data-name": "Path 6881",
    d: "M481.3,244.258c0,134.589-107.4,243.689-239.887,243.689S1.529,378.847,1.529,244.258,108.926.569,241.416.569,481.3,109.669,481.3,244.258",
    transform: "translate(-1.531 4.05)",
    fill: "#244277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M295.4,135.283c-13.314-20.3-43.627-13.013-48.937,10.121H143.334A66.018,66.018,0,0,0,107.511,91.6V46.588h92.053c1.791,8.984,8.924,17.846,17.648,20.6,24.508,7.725,44.779-19.032,31.241-40.956C235.874,5.86,204.9,11.505,199.907,34.753l-.744.552-95.243.065c-2.191.016-6.269,1.21-6.781,3.647V87.406a64.059,64.059,0,0,0-18.519-2.77c-35.887-.016-65,29.519-65.033,65.975-.04,36.472,29.042,66.064,64.945,66.1a63.788,63.788,0,0,0,18.607-2.762v48.324c0,2.039,4.95,3.858,6.781,3.647l90.7.057c.808.284,2.487,6.117,3.366,7.782,15.729,29.941,62.818,6.872,47.418-25.782-11.083-23.508-45.395-18.553-50.376,6.726H107.511V209.754a65.985,65.985,0,0,0,35.783-53.1l102.632-.089c1.871.374,2.479,5.069,3.446,7.035,16.608,33.548,67.288,4.11,46.026-28.317",
    transform: "translate(86.858 97.641)",
    fill: "#378c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6883",
    "data-name": "Path 6883",
    d: "M21.716,22.44h0Z",
    transform: "translate(151.929 159.834)",
    fill: "#378c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M90.3,37.942,50.248,85.331a11.318,11.318,0,0,1-9.771,0A304.675,304.675,0,0,1,18.4,62.936c-3.494-7.627,1.9-12.972,9.715-11.624,5.1.885,11.8,11.624,16.424,14.922L76.883,28.6a8.341,8.341,0,0,1,11.89,1.007,8.693,8.693,0,0,1,1.543,8.318",
    transform: "translate(112.928 189.255)",
    fill: "#f5f5f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizationMatrix);
export default __webpack_public_path__ + "static/media/AuthorizationMatrix.afbf02e3e9ecbd653645cacee07e6f03.svg";
export { ForwardRef as ReactComponent };